module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.912ec66d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 723
// module chunks = 0